// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F3aEVDlJhDw5mlr7b5uQ {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 100;

    width: 100vw;
    height: 100vh;

    display: flex;
    justify-content: center;
    align-items: center;

    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(5px);
    overflow: hidden;
}

.T4QemaYDHgRFn3OUMUjh {
    max-width: 600px;
    width: 60%;
    min-width: 425px;
    padding: 24px;

    background-color: white;
    border-radius: 5px;
    box-shadow: 0 1px 53px -5px rgba(0, 0, 0, 0.13);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.L7dqNHJDb0IJVgn_JKF7 {
    font-family: Raleway, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    margin-bottom: 4px;
    margin-top: 24px;
}

.k_viQOLXoHigo3drA5B4 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    text-align: center;
    margin-top: 8px;
    margin-bottom: 16px;
}

.FDGgAbSflb_C2AKnIUOE {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]};
    font-size: 24px;
    margin: 0;
}

.IMmMWDI1THNSWI126DHQ {
    max-width: 285px;
    width: 70%;
}

.H9Ss60Q2wLVWJIWGDozk {
    width: 100px;
}

.YAwSCJg2XM5i5QZt2gXB {
    width: 50px;
}

.gOTZDi6AW2SWlb8w2g8k {
    margin-top: 0;
    margin-bottom: 24px;
    font-size: 16px;
}

.q3v0f57GiAzlAqyEbyjb {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardPopup/DashboardPopup.module.css"],"names":[],"mappings":"AAGA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;;IAEZ,YAAY;IACZ,aAAa;;IAEb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,oCAAoC;IACpC,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,aAAa;;IAEb,uBAAuB;IACvB,kBAAkB;IAClB,+CAA+C;;IAE/C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mDAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mDAAkB;IAClB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf","sourcesContent":["@value colors: \"../../../components/library/style/colors.css\";\n@value color-text-subtle, color-error from colors;\n\n.background {\n    position: fixed;\n    top: 0;\n    right: 0;\n    z-index: 100;\n\n    width: 100vw;\n    height: 100vh;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    background: rgba(255, 255, 255, 0.5);\n    backdrop-filter: blur(5px);\n    overflow: hidden;\n}\n\n.popup {\n    max-width: 600px;\n    width: 60%;\n    min-width: 425px;\n    padding: 24px;\n\n    background-color: white;\n    border-radius: 5px;\n    box-shadow: 0 1px 53px -5px rgba(0, 0, 0, 0.13);\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.title {\n    font-family: Raleway, sans-serif;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 22px;\n    margin-bottom: 4px;\n    margin-top: 24px;\n}\n\n.description {\n    color: color-text-subtle;\n    text-align: center;\n    margin-top: 8px;\n    margin-bottom: 16px;\n}\n\n.daysLeft {\n    color: color-error;\n    font-size: 24px;\n    margin: 0;\n}\n\n.button {\n    max-width: 285px;\n    width: 70%;\n}\n\n.key {\n    width: 100px;\n}\n\n.security {\n    width: 50px;\n}\n\n.status {\n    margin-top: 0;\n    margin-bottom: 24px;\n    font-size: 16px;\n}\n\n.close {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../components/library/style/colors.css"`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"background": `F3aEVDlJhDw5mlr7b5uQ`,
	"popup": `T4QemaYDHgRFn3OUMUjh`,
	"title": `L7dqNHJDb0IJVgn_JKF7`,
	"description": `k_viQOLXoHigo3drA5B4`,
	"daysLeft": `FDGgAbSflb_C2AKnIUOE`,
	"button": `IMmMWDI1THNSWI126DHQ`,
	"key": `H9Ss60Q2wLVWJIWGDozk`,
	"security": `YAwSCJg2XM5i5QZt2gXB`,
	"status": `gOTZDi6AW2SWlb8w2g8k`,
	"close": `q3v0f57GiAzlAqyEbyjb`
};
export default ___CSS_LOADER_EXPORT___;
